var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline_General_Bank",
    "data-name": "Outline / General / Bank",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.067,
    height: 19.443,
    viewBox: "0 0 17.067 19.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .bankColored{fill:#8c8d99}.bankColored2{fill:#1bc47d}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bank",
    transform: "translate(-.467 -.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "bankColored",
    d: "M15.781 5.442H1.284A1.282 1.282 0 0 1 .572 3.1a16.686 16.686 0 0 1 4.391-2.09L7.948.088a1.979 1.979 0 0 1 1.17 0l2.985.917A16.686 16.686 0 0 1 16.494 3.1a1.282 1.282 0 0 1-.714 2.347zM8.533 1.5a.489.489 0 0 0-.144.022L5.4 2.439a15.279 15.279 0 0 0-3.37 1.5h13a15.253 15.253 0 0 0-3.369-1.5l-2.984-.917a.489.489 0 0 0-.144-.022z",
    transform: "translate(.467 .307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "bankColored",
    d: "M0 .75A.75.75 0 0 1 .75 0h14a.75.75 0 0 1 0 1.5h-14A.75.75 0 0 1 0 .75z",
    transform: "translate(1.25 18.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "bankColored2",
    d: "M0 6.75a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-1.5 0z",
    transform: "translate(3.25 8.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    className: "bankColored2",
    d: "M.75 7.5A.75.75 0 0 1 0 6.75v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-.75.75z",
    transform: "translate(8.25 8.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    className: "bankColored2",
    d: "M0 6.75a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-1.5 0z",
    transform: "translate(13.25 8.25)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankColored);
export default __webpack_public_path__ + "static/media/bank-colored.0823b3dc64fe0c3ed5ae91087fc1842e.svg";
export { ForwardRef as ReactComponent };